import handleResponse from './request/handleResponse'

export default function(fetch: GlobalFetch) {
  return async function(id: string) {
    const response = await fetch.fetch(
      `/api/v2/invoice/index/id_reservation/${id}`,
      {
        method: 'POST',
      },
    )
    return await handleResponse(response)
  }
}
